import { StepShareClasses } from '../../../common/components/StepShareClasses';
import { useSiSetShareClassMutation } from './ShareIssueStepper.graphql';
import { ShareIssueDocument } from '../../ShareIssue.graphql';
import { GqlCompany, GqlShareIssue } from '../../../../graphql/base-types.graphql';
import { useStepperStepContent } from '../../../../components/steppers/common/StepperStepContentContext';

export const SiStepShareClasses = ({
  company,
  shareIssue,
}: {
  company: Pick<GqlCompany, 'id' | 'shareClasses'>;
  shareIssue: Pick<GqlShareIssue, 'id' | 'shareClasses' | 'minNumberOfShares' | 'maxNumberOfShares'>;
}) => {
  const { validatorStatus } = useStepperStepContent();
  // eslint-disable-next-line sut/loading-mutation
  const [setShareClass] = useSiSetShareClassMutation({ refetchQueries: [ShareIssueDocument] });
  return (
    <StepShareClasses
      companyShareClasses={company.shareClasses}
      shareClasses={shareIssue.shareClasses}
      minNumberOfShares={shareIssue.minNumberOfShares}
      maxNumberOfShares={shareIssue.maxNumberOfShares}
      validatorError={validatorStatus}
      saveShareClass={async sc => {
        await setShareClass({ variables: { input: { ...sc, id: shareIssue.id }, companyId: company.id } });
      }}
    />
  );
};
